var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04087 10.9577C0.990326 10.7551 0.986612 10.5436 1.03001 10.3393C1.07341 10.135 1.16278 9.94327 1.29133 9.77866C1.41989 9.61405 1.58426 9.4809 1.77196 9.3893C1.95966 9.2977 2.16576 9.25006 2.37462 9.25H26.3546C26.5635 9.25006 26.7696 9.2977 26.9573 9.3893C27.145 9.4809 27.3094 9.61405 27.4379 9.77866C27.5665 9.94327 27.6558 10.135 27.6992 10.3393C27.7426 10.5436 27.7389 10.7551 27.6884 10.9577L25.1982 20.9169C25.0495 21.5118 24.7062 22.04 24.2229 22.4174C23.7396 22.7948 23.144 22.9999 22.5307 23H6.1985C5.58526 22.9999 4.98965 22.7948 4.50632 22.4174C4.023 22.04 3.67971 21.5118 3.53099 20.9169L1.04087 10.9591V10.9577Z",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2396 14V16.75",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4896 14V16.75",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11462 9.25L11.6146 1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6146 9.25L17.1146 1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.2986154099728da15d1baf8b754291a1.svg";
export { ForwardRef as ReactComponent };